import React, { memo, useEffect, useState } from 'react';

import { Form, Input, message, Modal, Typography } from 'antd';

import { updateOrgName } from '../services/SuperAdminActions';

const EditOrgModal = ({
  editOrganizationModal,
  setEditOrganizationModal,
  orgName,
  fetchOrganizations,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setEditOrganizationModal(false);
  };

  const editOrganozation = async () => {
    setLoading(true);
    const { org } = form.getFieldsValue();
    let trimmedName = org.trim();
    if (trimmedName === '') {
      message.error('Organization name cannot be empty');
      setLoading(false);
    } else {
      try {
        let inputData = {
          id: orgName.id,
          name: org,
        };
        await updateOrgName(inputData);
        message.success('Organization name updated successfully');
        handleCancel();
        await fetchOrganizations();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        throw error;
      }
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      org: orgName.name,
    });
    // eslint-disable-next-line
  }, [orgName]);

  return (
    <>
      <Modal
        open={editOrganizationModal}
        onCancel={handleCancel}
        okText="Save"
        onOk={editOrganozation}
        confirmLoading={loading}
      >
        <Typography.Title level={4}>Edit Organization Name</Typography.Title>
        <Form form={form} requiredMark={false} layout="vertical">
          <Form.Item
            label="Organization Name"
            name="org"
            rules={[
              {
                required: true,
                message: 'Please enter organization name',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default memo(EditOrgModal);

